import { useEffect } from 'react'

import { paymentMethodLabelDictionary } from 'enums/PaymentMethodType'
import { convertStrToDate } from 'utils/date'
import { IPetAfterSales } from 'store/afterSales/types'
import BridgeService from 'services/bridgeService'
import useBoundState from 'store'

import { Flex } from '@interco/inter-ui/components/Flex'
import { Text } from '@interco/inter-ui/components/Text'
import { formatToBRL } from '@interco/lib-util/'
import { Loading } from '@interco/inter-ui/components/Loading'

import { AfterSalesStatusTag } from '../Common/AfterSalesStatusTag/AfterSalesStatusTag'

interface IPetDetailsProps {
  afterSalesPet: IPetAfterSales
  hideCancelation: boolean
}

export const PetDetails = ({ afterSalesPet, hideCancelation }: IPetDetailsProps) => {
  const isLoading = useBoundState((state) => state.isLoading)

  useEffect(() => {
    BridgeService.tacWb({
      name: 'click_pet_after_sales',
      module: 'pet',
      actions: ['open_pet_details'],
      params: {
        afterSalesPet: JSON.stringify(afterSalesPet),
        hideCancelation: JSON.stringify(hideCancelation),
      },
    })
  }, [afterSalesPet, hideCancelation])

  return (
    <Flex direction="column" gap="16px">
      <Flex direction="row">
        <Text variant="body-3">Status</Text>
        <Text variant="body-3" bold colorWeight={500}>
          <AfterSalesStatusTag
            status={afterSalesPet.status}
            cancelDate={afterSalesPet.cancelDate}
          />
        </Text>
      </Flex>
      <Flex direction="row">
        <Text variant="body-3">Pet</Text>
        <Text variant="body-3" bold colorWeight={500}>
          {afterSalesPet?.name}
        </Text>
      </Flex>
      <Flex direction="row">
        <Text variant="body-3">Plano</Text>
        <Text variant="body-3" bold colorWeight={500}>
          {afterSalesPet?.planName}
        </Text>
      </Flex>
      <Flex direction="row">
        <Text variant="body-3">Localidade</Text>
        <Text variant="body-3" bold colorWeight={500}>
          {afterSalesPet?.location}
        </Text>
      </Flex>
      <Flex direction="row">
        <Text variant="body-3">Início de contratação</Text>
        <Text variant="body-3" bold colorWeight={500}>
          {convertStrToDate(afterSalesPet?.contractDate)}
        </Text>
      </Flex>
      <Flex direction="row">
        <Text variant="body-3">Valor mensalidade</Text>
        <Text variant="body-3" bold colorWeight={500}>
          {formatToBRL(Number(afterSalesPet?.price))}
        </Text>
      </Flex>
      {!hideCancelation && (
        <Flex direction="row">
          <Text variant="body-3">Data da próxima cobrança</Text>
          <Text variant="body-3" bold colorWeight={500}>
            {convertStrToDate(afterSalesPet?.paymentDate)}
          </Text>
        </Flex>
      )}
      {afterSalesPet?.cancelDate && (
        <Flex direction="row">
          <Text variant="body-3">Data de cancelamento</Text>
          <Text variant="body-3" bold colorWeight={500}>
            {convertStrToDate(afterSalesPet?.cancelDate)}
          </Text>
        </Flex>
      )}
      <Flex direction="row">
        <Text variant="body-3">Forma de pagamento</Text>
        {isLoading ? (
          <Loading width={24} height={24} />
        ) : (
          <Text variant="body-3" bold colorWeight={500}>
            {paymentMethodLabelDictionary[afterSalesPet?.paymentMethod]}
          </Text>
        )}
      </Flex>
    </Flex>
  )
}
